import { MenuItem } from "./MenuItem";
import { useNavigationActiveState, useNavigationState } from "./hooks";

import { SidebarGroup, SidebarGroupContent, SidebarMenu } from "@/components/ui/sidebar";

export const NavigationMenu = ({ onOpenSettings }: { onOpenSettings?: () => void }) => {
  const { isCollapsed, navigationItems, isMenuOpen, toggleMenu } =
    useNavigationState(onOpenSettings);

  const { isItemActive } = useNavigationActiveState();

  return (
    <SidebarGroup className="transition-all duration-300 ease-out">
      <SidebarGroupContent>
        <SidebarMenu className="space-y-0.5">
          {navigationItems.map(item => (
            <MenuItem
              key={item.name}
              item={item}
              isActive={isItemActive(item)}
              isCollapsed={isCollapsed}
              isOpen={isMenuOpen(item.name)}
              onToggle={hasSubItems => {
                toggleMenu(item.name, hasSubItems);
              }}
              isMenuOpen={isMenuOpen}
              toggleMenu={toggleMenu}
            />
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};
